import AdminApi from './AdminApi'
import * as config from '../../../config.js'
var Api = new AdminApi({
  url: config.API_ROOT
})

export default Api
